export type TabEnumName = 'entwuerfe' | 'gesendet';
export const TAB = {
  ENTWUERFE: 'entwuerfe' as TabEnumName,
  GESENDET: 'gesendet' as TabEnumName
};
